import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const RaAutocompleteInputStyles = {
    styleOverrides: {
        root: {
            minWidth: '276px',
            [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                minWidth: '100%',
            },
            '& .MuiAutocomplete-clearIndicator': {
                display: 'none',
            },
            '& .MuiFormControl-root': {
                marginTop: '4px',
                '& .MuiAutocomplete-endAdornment': {
                    marginTop: '-1px',
                    boxShadow: 'none !important',
                    '& .MuiAutocomplete-popupIndicator': {
                        boxShadow: 'none !important',
                        marginRight: '0 !important',
                    },
                },
            },
            '& + .MuiAutocomplete-popper': {
                inset: 'auto !important',
                transform: 'none !important',
                left: '0 !important',
                right: '0 !important',
                '&[data-popper-placement="bottom"]': {
                    top: '50px !important',
                    bottom: 'auto !important',
                },
                '&[data-popper-placement="top"], &[data-popper-placement="top-start"]': {
                    top: 'auto !important',
                    bottom: '103% !important',
                },
            },
        },
    },
};
